module.exports = __webpack_public_path__ + "static/media/mobile-app.de501fb4.png";